module.exports = __webpack_public_path__ + "static/undefeated-wts-tee-aaf4df50670812749a34cb18d26466eb.webp";